import Reviews from "../../layouts/Reviews";
import BookReviewTable from "../../components/reviews/BookReviewTable";

export default function BookReviews() {

    const rightContent = (
        <div>
            <BookReviewTable/>
        </div>
    )
    return (
        <div className="book-reviews-page">
            <Reviews rightContent={rightContent}/>
        </div>
    )
}
